<template>
  <div>
    <h6 class="tag-listing-filters-group-name">{{ group.tagGroupName }}</h6>
    <div
      class="tag-listing-filters-tag-entries"
      :class="getTagEntriesClassName"
    >
      <EntryFilter
        v-for="tagEntry in entries"
        :key="tagEntry.id"
        :entry="tagEntry"
        :group="group"
        class="tag-listing-filters-tag-entry"
      >
      </EntryFilter>
    </div>
  </div>
</template>

<script>

import EntryFilter from './EntryFilter'

export default {
  name: 'GroupFilter',
  components: {
    EntryFilter
  },
  props: {
    group: {
      tagDisplayType: '',
      tagGroupId: '',
      tagGroupName: null,
      tagGroupStep: 0,
      tagGroupDisplayPosition: 0,
      tags: []
    },
    entries: {
      type: Array
    },
    isBaseGroup: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getTagEntriesClassName () {
      let className = ''
      className += this.group.tagDisplayType
      return className
    }
  }
}
</script>
